import { render, staticRenderFns } from "./progetto-field.vue?vue&type=template&id=62fed44f"
import script from "./progetto-field.vue?vue&type=script&lang=js"
export * from "./progetto-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports